import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class MachinesTypesRequest extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.MACHINE_TYPES);
    }

}



// WEBPACK FOOTER //
// ./src/app/machines/ws/MachinesTypesRequest.js